<!-- =========================================================================================
    File Name: FileDownloadHistory.vue
    Description: File Download History page
========================================================================================== -->

<template>
  <div>
    <vx-card class="overflow-auto">
      <vs-button icon-pack="feather" icon="icon-download" @click="exportExcel()">{{$t('EXPORT_EXCEL')}}</vs-button>
      <v-server-table id="file-download-history-table" ref="fileDownloadHistoryTable" name="fileDownloadHistoryTable" 
        :columns="columns" :options="options" @loading="onLoading" @loaded="onLoaded" @sorted="setSortedForExcel" @filter="setFilterForExcelIncludeDateFilter">
        <vs-chip slot="reqStatus" slot-scope="props" :color="getReqStatusCodeColor(props.row.fileDownloadHistory.reqStatus)" class="w-full" >
          {{$t(getReqStatusCode(props.row.fileDownloadHistory.reqStatus))}}</vs-chip>
      </v-server-table>
    </vx-card>
  </div>
</template>

<script>
let FileSaver = require('file-saver');

import moduleUserFile from "@/store/userFile/moduleUserFile.js"

export default {
  components: {
  },
  data() {
    return {
      // Data Sidebar
      dataSidebar: false,
      sidebarData: {},
      
      // Table
      columns: ['userId', 'fileName', 'downloadDateTime', 'reqStatus'],
      options: {
        perPage:10,
        skin: 'table',
        filterByColumn: true,
        filterable: ['userId', 'fileName', 'downloadDateTime'],
        sortable: ['userId', 'fileName', 'downloadDateTime'],
        debounce: 1000,
        orderBy: { ascending: false },
        dateColumns: ['downloadDateTime'],
        dateFormat: 'YYYY-MM-DD',
        toMomentFormat: 'YYYYMMDD',
        datepickerOptions: {
            showDropdowns: true,
            autoUpdateInput: true,
        },
        sortIcon: {
          base: 'feather',
          up: 'icon-arrow-up',
          down: 'icon-arrow-down',
        },
        texts:{
          filterBy: this.$t("FILTER_BY"),
          defaultOption: this.$t("DEFAULT_OPTION"),
        },
        headings: {
          'userId' : () => this.$t("USER_ID"),
          'fileSeq': () => this.$t("FILE_SEQ"),
          'fileName': () => this.$t("FILE_NAME"),
          'reqStatus': () => this.$t("REQ_STATUS"),
          'downloadDateTime':() => this.$t("DOWNLOAD_DATETIME")
        },
        requestAdapter: function(data) {
          
          if(data.query.downloadDateTime){
            data.query = {...data.downloadDateTimeAdditional, ...data.query}

            let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            let start = moment.tz(data.query.downloadDateTime.start, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            let end = moment.tz(data.query.downloadDateTime.end, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            
            data.query.downloadDateTimeUTC.start = start
            data.query.downloadDateTimeUTC.end = end
          }

          return {
            ascending: data.ascending,
            byColumn: data.byColumn,
            pageSize: data.limit,
            orderBy: data.orderBy ? data.orderBy : "downloadDateTime",
            page: data.page,
            query: data.query,
            pageResult: ((data.page-1)*data.limit)
          };
        },
        params: {
          downloadDateTimeAdditional:{
            downloadDateTimeUTC: {
              start: '',
              end: ''
            },
          },
        },
        requestFunction: function (data) {
          return this.$http.get('/api/file-download-management/file-download-history', {
                params: data
          }).catch(function (e) {
                this.dispatch('error', e);
                this.$vs.loading.close()
          }.bind(this));
        },
        responseAdapter: (response) => {
          this.$store.commit('dataUserFile/SET_FILE_DOWNLOAD_HISTORY',response.data)
          return {
            data: this.$store.state.dataUserFile.fileDownloadHistoryList,
            count: this.$store.state.dataUserFile.fileDownloadHistoryCount
          }
        },
        templates:{
          userId: function(h,row){
            return row.user.userId;
          },
          fileSeq: function(h,row){
            return row.fileDownloadHistory.fileSeq;
          },
          fileName: function(h,row){
            return row.fileDownloadHistory.fileName;
          },
          downloadDateTime: function(h,row){
            let downloadDateTime = row.fileDownloadHistory.downloadDateTime
            if(!downloadDateTime){
              return '-'
            }else {
              let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
              let dateTime = this.$moment(downloadDateTime,'YYYYMMDDHHmmss').format()
              let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD HH:mm:ss')
              
              return dateTimeToLocal
            }

          }
        }
      }
    }
  },
  created() {
    if (!moduleUserFile.isRegistered) {
      this.$store.registerModule('dataUserFile', moduleUserFile)
      moduleUserFile.isRegistered = true
    }
  },
  mounted(){
     if (this.$route.params.userId){
        this.setSortedForExcel({
          name: "userId",
          value: this.$route.params.userId
        })
        this.$refs.fileDownloadHistoryTable.setSortedForExcel({
          userId: this.$route.params.userId
        })
     }
  },
  methods: {
    getReqStatusCode(code){
      if (code === "" ) return ""
      return this.$store.state.commonConfig.reqStatus.properties[code].name
    },
    getReqStatusCodeColor(code){
      if (code === "" ) return ""
      return this.$store.state.commonConfig.reqStatus.properties[code].color
    },
    exportExcel(){
      
      let locale = this.$i18n.locale

      this.$http({
        method: 'post',
        url: '/api/file-download-management/file-download-history/excel/'+locale,
        data:{
          query : JSON.stringify(this.filterForExcel),
          orderBy:  this.sortForExcel.column ? this.sortForExcel.column : 'downloadDateTime' ,
          ascending: this.sortForExcel.ascending ? 1 : 0 ,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        },
        withCredentials: true,
        responseType: 'blob',
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }).then((response) => {
        let excelTitle
        if (locale === "ko") {
          excelTitle = "파일_다운로드_이력.xlsx"
        } else {
          excelTitle ="File_Download_History.xlsx"
        }
        FileSaver.saveAs(response.data, excelTitle)
      }).catch((error)=> {
        console.log(error);
      }) 
    }
  },
}

</script>

<style lang="scss" scoped>
#file-download-history-table {
  text-align: center;
}
</style>